module.exports = __webpack_public_path__ + "img/DKG-logo-breed-path-m2.72f3ae94.svg";